import * as React from 'react';

import { Heading, Stack, StackProps, Text } from '@chakra-ui/react';

import { FONTS_OPACITY } from '@/constant';

export interface PageTitleProps extends StackProps {
  title: string;
  subtitle?: string;
}

const PageTitle = React.forwardRef<HTMLDivElement, PageTitleProps>(
  ({ title, subtitle, ...props }, ref) => {
    return (
      <Stack ref={ref} {...props}>
        <Heading size='headingSecondary'>{title}</Heading>
        {subtitle && <Text opacity={FONTS_OPACITY}>{subtitle}</Text>}
      </Stack>
    );
  }
);
PageTitle.displayName = 'PageTitle';

export { PageTitle };
